import { extendObservable } from 'mobx'

import { expertApi } from '@atheneum/api'


class ExpertSidebarStore {
  constructor () {
    extendObservable(this, {
      expert: null,
      loading: false
    })
  }

  async load (id, eplId) {
    this.loading = true
    this.expert = await expertApi.getOne(id, eplId)
    this.loading = false
  }
}

export default ExpertSidebarStore
